// extracted by mini-css-extract-plugin
module.exports = {"clearAllButton":"FiltersLayout_clearAllButton__4iB-I","filtersContainer":"FiltersLayout_filtersContainer__1nWGs","filterBadge":"FiltersLayout_filterBadge__1CoWo"};